import { render } from "./Research.vue?vue&type=template&id=b5781cd8&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=b5781cd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5781cd8"]])

export default __exports__